/**
 * PEP-1298 - eksperyment Matomo A/B Testing sterujący kolejnością grup Apple Pay / Google Pay.
 *
 * ⚠️ Wtyczka A/B Testing NIE pobiera konfiguracji z serwera - proporcje, daty i warianty żyją
 * wyłącznie w opcjach `AbTesting::create`, czyli tutaj. Zmiana w panelu Matomo bez podmiany tych
 * wartości i wdrożenia nie zadziała. Nazwy muszą być identyczne z panelem (site 47 i 48), bo
 * raporty łączą zdarzenia z eksperymentem po nazwie.
 *
 * Wartości przepisane z kodu osadzenia (`AbTesting.getJsExperimentTemplate`, site 48, id 11).
 * Warianty nie mają `percentage`, więc wtyczka dzieli ruch po równo.
 */
export const WALLET_ORDER_VARIANT = {
  original: 'original', // kolejność z API - grupa kontrolna (nazwa narzucona przez wtyczkę)
  byDevice: 'wg_urzadzenia', // Apple Pay wyżej, gdy dostępny na urządzeniu; inaczej Google Pay wyżej
}

export const WALLET_ORDER_EXPERIMENT = {
  name: 'KolejnoscPortfeli',
  percentage: 100,
  includedTargets: [{ attribute: 'url', type: 'any', value: '', inverted: '0' }],
  excludedTargets: [],
}
